/*!
 * Load list content via ajax
 *
 * Version: 1.0
 * Author: MS
 */
(function($)
{
	/**
	 * AJAX Loader
	 */
	var WHAjaxLoader = function(element, options)
	{
		var instance 	= this;
		this.element 	= $(element);
		this.is_loading = false;

		this.settings 	= $.extend(
		{
			// When set to true the content will be automatically loaded
			auto_load 			: true,

			// Selector for the paged navigation (it will be hidden)
			// DOM-Element that is placed at the bottom of the content
			// and that will be used to check if the new content
			// should be loaded
			nav_selector 		: '#load_next_link',

			// Selector for the link to the content of the next page
			next_selector 		: '#load_next_link a',

			// Name of the attribute that contains the url for the ajax request.
			// Default: the href attribute of the link is used
			// Alternative: data-next-url
			'url_attribute'		: 'href',

			// HTML that will be injected when content is loaded
			loading_html 		: 'Loading...',

			// Function that will be called when new content was loaded
			on_content_loaded	: null,

			// Enable debugging
			debug 				: false

		}, options || {});

		// Init
		instance.init();
	};

	/**
	 * Init bindings
	 */
	WHAjaxLoader.prototype.init = function()
	{
		var instance = this;

		// Auto load on scroll
		if (this.settings.auto_load)
		{
			$(window).scroll(function()
			{
				instance.check_scroll_position();
			});

			// Load initially
			instance.check_scroll_position();
		}

		this.bind_click();

		if (this.settings.debug)
		{
			console.log('wh ajax loader initialized', instance);
		}
	};

	WHAjaxLoader.prototype.bind_click = function()
	{
		var instance = this;

		// Manually load on click
		instance.element.on('click', instance.settings.next_selector, function(e)
		{
			e.preventDefault();

			if (instance.settings.debug)
			{
				console.log("click on next");
			}

			instance.load();
			return false;
		});
	};

	/**
	 * Checks if new content should be loaded based on the scroll position
	 */
	WHAjaxLoader.prototype.check_scroll_position = function()
	{
		var bottom_scroll_position = $(window).scrollTop() + $(window).height();
		var $nav_element = $(this.settings.nav_selector);
		if ($nav_element.length > 0 && bottom_scroll_position >= $nav_element.offset().top)
		{
			this.load();
		}
	};

	/**
	 * Loads new content via AJAX
	 */
	WHAjaxLoader.prototype.load = function()
	{
		var instance = this;

		if (!this.is_loading)
		{
			this.is_loading = true;

			// Get the url
			var $next_selector = $(this.settings.next_selector);
			var url = $next_selector.attr(this.settings.url_attribute);

			if (this.settings.debug)
			{
				console.log("Loading: " + url);
			}

			// Hide the link for bots
			$(this.settings.nav_selector).remove();

			// Show loading indicator
			$(this.element).append('<span id="ajax_loader">' + this.settings.loading_html + '</span>');

			$.ajax( {
				type: "get",
				url: url
			}).done(function(html)
			{
				instance.is_loading = false;

				// Remove AJAX-Div
				$('#ajax_loader').remove();

				// Append the new HTML
				$(instance.element).append(html);

				// Bind click event of new added next link
				instance.bind_click();

				// Callback
				if (typeof(instance.settings.on_content_loaded) == 'function')
				{
					instance.settings.on_content_loaded(instance, $next_selector);
				}
			});
		}
	};

	$.fn.wh_ajax_loader = function(options)
	{
		return this.each(function()
		{
			var element = $(this);

			// Check if this element already has a plugin instance
			if (!element.data('wh_ajax_loader'))
			{
				var plugin_instance = new WHAjaxLoader(this, options);

				// Store plugin object in this element's data
				element.data('wh_ajax_loader', plugin_instance);
			}

		});
	};
})(jQuery);